import { render, staticRenderFns } from "./deliverystatusreport.vue?vue&type=template&id=95cb78de&"
import script from "./deliverystatusreport.vue?vue&type=script&lang=js&"
export * from "./deliverystatusreport.vue?vue&type=script&lang=js&"
import style0 from "./deliverystatusreport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports